import cn from 'classnames';
import { useEffect, useState } from 'react';
import { type ContactType } from '@widgets/contacts/contact-edit/constans.tsx';
import {
  ContactInstagramIcon,
  ContactMailIcon,
  ContactPhoneIcon,
  ContactSkypeIcon,
  ContactTelegramIcon,
  ContactViberIcon,
  ContactVKIcon,
  ContactWhatsUpIcon,
  SelectArrow,
} from '@shared/assets';
import type { SelectOption } from '@shared/types/contacts';
import { Card } from '@shared/ui';
import * as st from './style.module.scss';

interface Props {
  contactOption: ContactType;
  setContactOption: (type: ContactType) => void;
  wrapperClassName?: string;
  fullWidth?: boolean;
}

const selectMap: SelectOption[] = [
  {
    type: 'phone',
    verb_name: 'Телефон',
    icon: <ContactPhoneIcon />,
  },
  {
    type: 'email',
    verb_name: 'Почта',
    icon: <ContactMailIcon />,
  },
  {
    type: 'telegram',
    verb_name: 'Telegram',
    icon: <ContactTelegramIcon />,
  },
  {
    type: 'vk',
    verb_name: 'ВКонтакте',
    icon: <ContactVKIcon />,
  },
  {
    type: 'whatsapp',
    verb_name: 'WhatsApp',
    icon: <ContactWhatsUpIcon />,
  },
  {
    type: 'viber',
    verb_name: 'Viber',
    icon: <ContactViberIcon />,
  },
  {
    type: 'skype',
    verb_name: 'Skype',
    icon: <ContactSkypeIcon />,
  },
  {
    type: 'instagram',
    verb_name: 'Instagram',
    icon: <ContactInstagramIcon />,
  },
];

export const SelectType: React.FC<Props> = ({
  contactOption,
  setContactOption,
  wrapperClassName,
  fullWidth,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<SelectOption | null>(null);

  useEffect(() => {
    const item = selectMap.find((option) => option.type === contactOption);
    if (item) {
      setSelectedItem(item);
    }
  }, [selectedItem, contactOption]);

  const handleClickButton = () => {
    setOpen((prev) => !prev);
  };

  const handleSelectItem = (type: ContactType) => {
    const item = selectMap.find((option) => option.type === type);
    if (item) {
      setContactOption(type);
      setSelectedItem(item);
      setOpen(false);
    }
  };

  return (
    <div className={cn(st.wrapper, wrapperClassName, fullWidth && st.fullWidth)}>
      <div className={st.fieldset}>
        <span className={st.nameList}>Название</span>
        <button className={st.selectedBtn} onClick={handleClickButton} type="button">
          <div className={st.selectedBtn__left}>
            <div className={`${st.info__icon} ${selectedItem && st[selectedItem.type]}`}>
              {selectedItem?.icon}
            </div>
            {selectedItem?.verb_name}
          </div>
          <SelectArrow />
        </button>
      </div>
      {isOpen && (
        <Card className={st.card}>
          <ul className={st.list}>
            {selectMap.map((selectItem) => (
              <li
                className={st.list__item}
                key={selectItem.type}
                onClick={() => handleSelectItem(selectItem.type)}
              >
                <div className={`${st.info__icon} ${st[selectItem.type]}`}>{selectItem.icon}</div>
                {selectItem.verb_name}
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
};
